// extracted by mini-css-extract-plugin
export default {"wrapper":"feature_wrapper__Qony7","feature__card":"feature_feature__card__vwKV5"};